// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5217":"185890ea639292b2","8857":"d4e5afac14194536"}[chunkId] + ".js";
};